import { html, mount, safeUrl } from '../core/html.js';
import { get } from '../core/api.js';
import { statusBadge, emptyState } from '../core/ui.js';
import { fmtDateShort, rm } from '../core/format.js';
import { t } from '../core/i18n.js';

const TABS = [
  ['upcoming', (b) => ['CONFIRMED', 'PENDING_PAYMENT', 'PAYMENT_PROCESSING'].includes(b.status)],
  ['active', (b) => ['CHECKED_IN', 'DISPUTED'].includes(b.status)],
  ['completed', (b) => b.status === 'COMPLETED'],
  ['cancelled', (b) => b.status === 'CANCELLED'],
  ['refunded', (b) => ['REFUNDED', 'REFUND_PENDING'].includes(b.status)],
];

export async function render(main, _p, query) {
  const tab = query.get('tab') || 'upcoming';
  const all = await get('/api/bookings?role=guest&limit=100');
  const now = Date.now();
  // Tempahan menunggu bayaran yang tamat tempoh tahanan disembunyikan daripada "Akan datang".
  const visible = all.filter((b) => !(['PENDING_PAYMENT', 'PAYMENT_PROCESSING'].includes(b.status) && b.hold_expires_at < now));
  const [, fn] = TABS.find((x) => x[0] === tab) || TABS[0];
  const rows = visible.filter(fn);
  mount(main, html`<div class="wrap" style="padding-top:20px;max-width:900px">
    <h1>${t('bookings.title')}</h1>
    <div class="tabs" role="tablist">${TABS.map(([k, f]) => html`<a role="tab" href="#/bookings?tab=${k}" aria-selected="${k === tab}">${t(`bookings.tab_${k}`)} (${visible.filter(f).length})</a>`)}</div>
    ${rows.length ? html`<div class="list">${rows.map((b) => html`<a class="item" href="#/${['PENDING_PAYMENT', 'PAYMENT_PROCESSING'].includes(b.status) ? 'checkout' : 'bookings'}/${b.id}">
      ${b.snapshot.property_photo ? html`<img src="${safeUrl(b.snapshot.property_photo)}" alt="">` : html`<span class="ph"></span>`}
      <span class="grow"><b data-ugc>${b.snapshot.property_name}</b><div class="small muted">${fmtDateShort(b.check_in)} – ${fmtDateShort(b.check_out)}, ${t('common.guests_n', { n: b.guests })}</div><div class="small">${rm(b.fin.guest_total_minor)}</div></span>
      ${statusBadge(b.status, 'booking')}</a>`)}</div>`
    : emptyState(tab === 'upcoming' ? t('bookings.empty_upcoming') : t('bookings.empty'), t('bookings.empty_text'), html`<a class="btn btn-primary" href="#/search">${t('bookings.find')}</a>`)}
  </div>`);
}
